import React from 'react';
import PropTypes from 'prop-types';

import { AuthFilter } from '../auth/AuthFilters';
import StandardLayout from '../StandardLayout';

import CreateRollcall from './CreateRollcallController';

export default class extends React.Component {

    static propTypes = {
        onSuccess: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    }
    
    render() {
        
        return (
            <AuthFilter onMismatch={this.props.onMismatch}>
                <StandardLayout>
                    <CreateRollcall onSuccess={this.props.onSuccess} onCancel={this.props.onCancel}/>
                </StandardLayout>
            </AuthFilter>
        );
    }
}